import React, { useEffect, useState } from 'react'
import { PHSHeader } from '../../components/UI/header'
import DataTable from '../../components/UI/table'
import { styles } from './index.sass'
import { Button, message, InputNumber } from 'antd'
import { CheckOutlined, EditOutlined } from '@ant-design/icons'
import { getSessionUpdateRequest, approveSessionUpdateRequest } from '../../api/appointments'
import { useLocation } from 'react-router-dom'
import { loadUser } from '../../utils'

export const SessionUpdateReview = () => {
    const location = useLocation()
    const [loading, setLoading] = useState(false)
    const [sessionUpdateRequest, setSessionUpdateRequest] = useState(null)
    const [editableSessions, setEditableSessions] = useState(null)

    const getRequestId = () => {
        const params = new URLSearchParams(location.search)
        return params.get('requestId')
    }

    const columns = [
        { title: 'Client ID', dataIndex: 'client_id', key: 'client_id', align: 'center' },
        {
            title: 'Client Name',
            dataIndex: 'client',
            key: 'client',
            render: (client) => client && client.full_name ? client.full_name : 'N/A',
            align: 'center'
        },
        { title: 'Invoice Type', dataIndex: 'invoice_type', key: 'invoice_type', align: 'center' },
        {
            title: 'Invoice Date',
            dataIndex: 'invoice_date',
            key: 'invoice_date',
            render: (date) => date ? new Date(date).toLocaleDateString() : 'N/A',
            align: 'center'
        },
        {
            title: 'Paid Date',
            dataIndex: 'paid_date',
            key: 'paid_date',
            render: (date) => date ? new Date(date).toLocaleDateString() : 'N/A',
            align: 'center'
        },
        {
            title: 'Sessions to Allocate',
            dataIndex: 'sessions_to_allocate',
            key: 'sessions_to_allocate',
            align: 'center',
            render: (text, record) => {
                if (editableSessions === record.id) {
                    return (
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                            <InputNumber
                                min={1}
                                max={1000}
                                value={sessionUpdateRequest.sessions_to_allocate}
                                onChange={(value) => handleSessionsChange(value, record)}
                                style={{ width: 120 }}
                            />
                            <Button
                                type="text"
                                icon={<CheckOutlined />}
                                size="small"
                                onClick={() => setEditableSessions(null)}
                                disabled={record.status === 'approved'}
                            />
                        </div>
                    )
                }
                return (
                    <div>
                        {text}
                        <Button
                            type="text"
                            icon={<EditOutlined />}
                            size="small"
                            onClick={() => setEditableSessions(record.id)}
                            disabled={record.status === 'approved'}
                        />
                    </div>
                )
            }
        },
        {
            title: 'Amount',
            dataIndex: 'amount',
            key: 'amount',
            render: (amount) => amount ? `$${amount}` : 'N/A',
            align: 'center'
        },
        {
            title: 'Notes',
            dataIndex: 'notes',
            key: 'notes',
            render: (notes) => notes ? notes : 'N/A',
            align: 'center'
        },
        { title: 'Status', dataIndex: 'status', key: 'status', align: 'center' },
        {
            key: 'actions',
            title: 'Actions',
            render: (text, record) => {
                return (
                    <div>
                        <Button
                            type="primary"
                            onClick={() => onClickApprove(record)}
                            disabled={record.status === 'approved'}
                        >
                            {record.status === 'approved' ? (
                                <>
                                    <CheckOutlined /> Approved
                                </>
                            ) : (
                                <>
                                    <CheckOutlined /> Approve
                                </>
                            )}
                        </Button>
                    </div>
                )
            },
            align: 'center'
        }
    ]

    const handleSessionsChange = (value, record) => {
        setSessionUpdateRequest({
            ...sessionUpdateRequest,
            sessions_to_allocate: value
        })
    }

    const fetchSessionUpdateRequest = async () => {
        const requestId = getRequestId()
        if (!requestId) {
            console.error('Request ID is missing')
            return
        }

        setLoading(true)
        try {
            const response = await getSessionUpdateRequest(requestId)
            console.log('Session update request response:', response)
            setSessionUpdateRequest(response.data)
        } catch (error) {
            console.error('Error fetching session update request:', error)
            message.error('Failed to fetch session update request details')
        }
        setLoading(false)
    }

    const onClickApprove = async (record) => {
        setLoading(true)
        try {
            const approvedBy = loadUser && loadUser().id

            await approveSessionUpdateRequest(record.id, {
                approved_by: approvedBy,
                sessions_to_allocate: sessionUpdateRequest.sessions_to_allocate
            })
            message.success('Session update request approved and sessions allocated')
            fetchSessionUpdateRequest()
        } catch (error) {
            console.error('Error approving session update request:', error)
            message.error('Failed to approve session update request')
        }
        setLoading(false)
    }

    useEffect(() => {
        console.log('Location search:', location.search)
        fetchSessionUpdateRequest()
    }, [location.search])

    const dataSource = sessionUpdateRequest ? [sessionUpdateRequest] : []

    return (
        <div className={styles}>
            <PHSHeader
                hideBreadCrumb={true}
                hideSubHeader={true}
            />
            <div className='container'>
                <h2>Session Update Review</h2>
                <div>
                    <DataTable
                        columns={columns || []}
                        dataSource={dataSource || []}
                        loading={loading}
                        hidePagination={true}
                        rowKey="id"
                    />
                </div>
            </div>
        </div >
    )
}
